module.exports = __webpack_public_path__ + "img/1970East-033_WEB-min.afc9265e.jpg";